export default __webpack_public_path__ + "static/5-artificial-intelligence-4f8d37f2606a9e9b9e96addfd409c472.png";